import React, { useEffect } from 'react';
import styles from './Filter.module.scss';

import DialogWrapper from 'components/DialogComponents/DialogWrapper';
import { FormLabel } from 'components/FormComponents';
import { FilterActions, FilterHeader } from 'components/FilterComponentsV2';
import FormAutoMultiSelect from 'components/FormComponents/FormAutoMultiSelect/FormAutoMultiSelect';
import FormCheckbox from 'components/FormComponents/FormCheckbox/FormCheckbox';
import FormMultiSelect from 'components/FormComponents/FormMultiSelect/FormMultiSelect';

import { FormProvider, useForm } from 'react-hook-form';
import { useTrainingsSelector } from 'hooks/Trainings';
import { useMobileViewport } from 'hooks/useMobileViewport';

import { defaultFilter } from '../helpers';

import clsx from 'clsx';

export function Filter({ open, setOpen, onApply }) {
  const isMobile = useMobileViewport();

  const methods = useForm({
    defaultValues: { ...defaultFilter },
    mode: 'onChange'
  });
  const { getValues, reset, setValue } = methods;

  const { filter, filterCriteria } = useTrainingsSelector();

  const { externalTrainings, groupTrainings, source } = filterCriteria;

  useEffect(() => {
    if (open) {
      reset(filter.filters);
    }
  }, [open]);

  const closePopup = () => setOpen(false);

  const applyFilter = () => {
    onApply(getValues());
    closePopup();
  };

  const clearFilter = () => {
    const defaultState = { ...defaultFilter.filters, searchQuery: getValues('searchQuery') };
    reset(defaultState);
  };

  const handleMultiSelect = (name, value) => setValue(name, value);

  return (
    <DialogWrapper open={open} onClose={closePopup}>
      <div className={styles.dialog}>
        {isMobile && <FilterHeader title="Filters" onBack={closePopup} />}
        <FormProvider {...methods}>
          <div className={styles.form}>
            <div className={styles.form__block}>
              <div className={styles.form__block_cell}>
                <FormLabel>Training & Certifications</FormLabel>
                <FormAutoMultiSelect
                  name="externalTrainingIds"
                  menuItems={externalTrainings || []}
                  options={{
                    label: 'name',
                    disableByObjectTracker: true,
                    disableLabel: true
                  }}
                />
              </div>
              <div className={styles.form__block_cell}>
                <FormLabel>Group</FormLabel>
                <FormAutoMultiSelect
                  name="groupIds"
                  menuItems={groupTrainings || []}
                  options={{
                    label: 'name',
                    disableByObjectTracker: true,
                    disableLabel: true
                  }}
                />
              </div>
            </div>
            <div className={styles.form__block}>
              <div className={styles.form__block_cell}>
                <FormLabel>Source</FormLabel>
                <FormMultiSelect
                  trackById
                  name="sourceIds"
                  options={source || []}
                  onSelect={handleMultiSelect}
                />
              </div>
              <div className={clsx(styles.form__block_cell, styles.checkbox)}>
                <FormLabel>Available only</FormLabel>
                <FormCheckbox name="showAvailable" />
              </div>
            </div>
          </div>
        </FormProvider>
        <FilterActions onClear={clearFilter} onCancel={closePopup} onApply={applyFilter} />
      </div>
    </DialogWrapper>
  );
}
